import fetch from 'isomorphic-fetch';
import API_URL from 'helpers/apiURL';

/* ----------------------- List ----------------------- */
export const requested = () => ({ type: 'SHIFT_REQUESTED' });

export const request = (data, brandId) => {
  return function(dispatch) {
    dispatch(requested());

    const form = new FormData();

    form.append('data', JSON.stringify(data));

    return fetch(`${API_URL}/request?brand_id=${brandId}`, {
      method: 'POST',
      body: form,
    })
      .then(response => response.json())
      .then(json => dispatch(shiftConfirmed(json)))
      .catch(() => dispatch(shiftFailed()));
  };
};

export const shiftConfirmed = response => ({
  type: 'SHIFT_CONFIRMED',
  code: response.data.code,
});

export const shiftFailed = response => ({
  type: 'SHIFT_FAILED',
});
